interface Props {
  currentStep: number
  totalSteps: number
}

const stepIcons = ['category', 'person', 'palette', 'link', 'check_circle']
const stepLabels = ['Type', 'Profile', 'Theme', 'Links', 'Review']

export function WizardStepIndicator({ currentStep, totalSteps }: Props) {
  return (
    <div className="flex items-center justify-center gap-0 w-full max-w-lg mx-auto">
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1
        const isCompleted = step < currentStep
        const isCurrent = step === currentStep
        const isActive = isCompleted || isCurrent

        return (
          <div key={step} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center gap-1.5">
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center transition-all ${
                  isActive
                    ? 'bg-[#2B6CEE] text-white shadow-md'
                    : 'bg-gray-100 dark:bg-white/10 text-gray-400 dark:text-gray-500'
                }`}
              >
                <span className="material-symbols-outlined text-[18px]">
                  {isCompleted ? 'check' : stepIcons[i]}
                </span>
              </div>
              <span
                className={`text-[11px] font-medium ${
                  isActive ? 'text-[#2B6CEE]' : 'text-gray-400 dark:text-gray-500'
                }`}
              >
                {stepLabels[i]}
              </span>
            </div>
            {step < totalSteps && (
              <div
                className={`flex-1 h-0.5 mx-2 mb-5 transition-colors ${
                  isCompleted ? 'bg-[#2B6CEE]' : 'bg-gray-200 dark:bg-white/10'
                }`}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
